import { WeekDays } from '@griply/types';
import { Day } from 'date-fns';

export const weekdaysNumberMap: Record<WeekDays, Day> = {
  [WeekDays.Monday]: 1,
  [WeekDays.Tuesday]: 2,
  [WeekDays.Wednesday]: 3,
  [WeekDays.Thursday]: 4,
  [WeekDays.Friday]: 5,
  [WeekDays.Saturday]: 6,
  [WeekDays.Sunday]: 0,
};

export const HALF_HOUR = 30 * 60 * 1000;

export const featurebaseFeatureBoardUrl =
  'https://griply.featurebase.app/?b=69674e9d905acfac3f350533';

export const featurebaseBugBoardUrl =
  'https://griply.featurebase.app/?b=699711997d02eaea89ddfc47';
